/** Shared history cadence: quick enough for pipeline state, trivial for an internal user count. */
export const RUN_REFRESH_MS = 2_000;

/** Allow the five-second auth deadline plus a healthy database round trip before exposing Retry. */
export const RUN_REQUEST_TIMEOUT_MS = 15_000;

/** Keep the picker bounded even when the shared successful-run library grows. */
export const SOURCE_PAGE_SIZE = 24;

/** Evict offscreen thumbnail blobs as additional source pages are traversed. */
export const MAX_PICKER_PREVIEWS = 24;

/** Bound remote claims verification so polling cannot retain handlers indefinitely. */
export const CLAIMS_VERIFICATION_TIMEOUT_MS = 5_000;

/** Give a shed media request a short, explicit retry window. */
export const GIFME_MEDIA_BUSY_RETRY_AFTER_SECONDS = 1;

/** Keep one browser below the origin's two-active plus eight-queued envelope. */
export const MAX_GIFME_BROWSER_MEDIA_REQUESTS = 4;

/** Allow a 100 MiB rendition about one minute at 14 Mbps before releasing its browser lane. */
export const MAX_GIFME_BROWSER_MEDIA_ATTEMPT_MS = 60_000;

/** Recover transient contention without allowing an indefinite browser loop. */
export const MAX_GIFME_BROWSER_MEDIA_BUSY_RETRIES = 2;

/** Never let a malformed Retry-After stall one browser media request for long. */
export const MAX_GIFME_BROWSER_MEDIA_RETRY_DELAY_MS = 5_000;

/** Keep recipient-to-studio handoffs short-lived without requiring server-side session state. */
export const SHARE_HANDOFF_MAX_AGE_SECONDS = 30 * 60;
